// extracted by mini-css-extract-plugin
module.exports = {"flight":"flight-1-H3h","segments":"segments-sjo3E","selected":"selected-3XzJH"};